/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2025-02-17 10:16:50
 **/

import { EventEmitter } from "eventemitter3";

export type PublishOptions = Partial<{
	retain: boolean;
	qos: number;
}>;

export type Packet<T = object> = {
	topic: string;
	payload: T | null;
};

export default abstract class NetworkInterface extends EventEmitter {
	public abstract get is_connected(): boolean;

	public abstract get topics(): string[];
	public abstract set topics(value: string[]);

	public abstract connect(): Promise<NetworkInterface>;
	public abstract disconnect(): Promise<void>;
	public abstract subscribe(topic: string | string[]): void;
	public abstract unsubscribe(topic: string | string[]): void;

	public abstract publish<T = any>(topic: string, payload: T, options?: PublishOptions | null): Promise<Packet<T>>;
}
